// extracted by mini-css-extract-plugin
export default {"removeUsersConfirmDialog":"RemoveUsersConfirmDialog-module_removeUsersConfirmDialog__dMQ9Rp","actionButtons":"RemoveUsersConfirmDialog-module_actionButtons__n762ZV"};